export default __webpack_public_path__ + "static/media/event-asia-baner.759c3cad.png";